export enum ENTITY_TYPE {
  TABLE = 'r',
  VIEW = 'v',
  MATERIALIZED_VIEW = 'm',
  FOREIGN_TABLE = 'f',
  PARTITIONED_TABLE = 'p',
}
